import Rellax from "rellax";

(function ($, Drupal, once) {
  Drupal.behaviors.histally_text_image = {
    attach(context) {

      var topOffsetProductInfo, heightProductInfo;

      function proInfoAnimaitonVariables() {
        if ($('.histally-text-and-media-component').length) {
          topOffsetProductInfo = $('.histally-text-and-media-component', context).offset().top;
          heightProductInfo = $('.histally-text-and-media-component', context).outerHeight();
        }
      }

      // $(document, context).once('histally_text_image').each(function () {
      //   proInfoAnimaitonVariables();
      // });
      $(once('histally_text_image', '.histally-text-and-media-component', context)).each(function () {
        proInfoAnimaitonVariables(this);
      });

      // $(document, context).once('histally_text_image_ajax').ajaxSuccess(function () {
      //   proInfoAnimaitonVariables();
      // });
      $(once('histally_text_image_ajax', document)).ajaxSuccess(function () {
        proInfoAnimaitonVariables();
      });

      var bottomOffsetProductInfo = topOffsetProductInfo + heightProductInfo;
      var hasFunctionRun = false;
      var destroyRellax = false;
      var rellax_product_info;
      var currentScroll = $(window).scrollTop();

      function proInfoAnimaiton() {
        if (window.innerWidth >= 1366) {
          rellax_product_info = new Rellax('.element');
        }
        hasFunctionRun = true;
        destroyRellax = true;
        window.removeEventListener("scroll", proInfoAnimaiton);
      }

      $(window).on('scroll', function (event) {
        currentScroll = $(window).scrollTop();
        var sectionInView = (currentScroll > (topOffsetProductInfo + 200));

        if (window.innerWidth >= 1366) {
          if (sectionInView) {
            if (!hasFunctionRun) {
              proInfoAnimaiton();
            }
          }
          else {
            if (destroyRellax) {
              rellax_product_info.destroy();
            }
            hasFunctionRun = false;
          }

          // Image left scroll animation.
          if (currentScroll > (topOffsetProductInfo - 200)) {
            $('.animate-left-to-right', context).addClass('animated');
          }
          else {
            $('.animate-left-to-right', context).removeClass('animated');
          }

          // Image opacity animation.
          if (currentScroll > (bottomOffsetProductInfo - 550)) {
            $('.animate-left-to-right', context).addClass('low-opacity');
            $('.animate-left-to-right', context).removeClass('high-opacity');
          }
          else {
            $('.animate-left-to-right', context).removeClass('low-opacity');
            $('.animate-left-to-right', context).addClass('high-opacity');
          }
        }
      });

      $(document).ready(function () {
        $(".more-ingredients-link a").click(function (event) {
          event.preventDefault(); // Prevent default anchor action
          $(".more-ingredients-desc").show(); // Toggle the description visibility
        });
      });

    },
  };
})(jQuery, Drupal, once);
